export default (contacts) => contacts.filter(({tags}) => tags?.some(({isCustom}) => !isCustom));
